import get from 'lodash/get';

export const Team = data => ({
  id: data.id,
  displayName: data.displayName,
  icon: data.icon,
});

export const responseDataToTeam = responseData => {
  return new Team({
    id: get(responseData, 'id'),
    displayName: get(responseData, 'attributes.displayName'),
    icon: get(responseData, 'attributes.icon'),
  });
};

export const responseToTeamList = response => {
  if (Array.isArray(get(response, 'data.data'))) {
    return response.data.data.map(responseDataToTeam);
  }
  return [responseDataToTeam(get(response, 'data.data'))];
};
